var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wkb-expand-history" }, [
    _c("p", { staticClass: "wkb-expand-history-intro" }, [
      _vm._v(
        " These runs added nodes to the graph from your expansion seeds (selected nodes, a single node, or both endpoints of an edge). "
      ),
    ]),
    !_vm.entries.length
      ? _c("p", { staticClass: "wkb-expand-history-empty" }, [
          _vm._v(
            " No expansion runs have been recorded for this session yet. "
          ),
        ])
      : _c(
          "ul",
          {
            staticClass: "wkb-expand-history-list",
            attrs: { "aria-label": "Expansion history" },
          },
          _vm._l(_vm.entries, function (entry) {
            return _c(
              "li",
              { key: entry.id, staticClass: "wkb-expand-history-item" },
              [
                _c("div", { staticClass: "wkb-expand-history-head" }, [
                  _c("strong", { staticClass: "wkb-expand-history-title" }, [
                    _vm._v(_vm._s(entry.title)),
                  ]),
                  _c(
                    "div",
                    { staticClass: "wkb-expand-history-head-actions" },
                    [
                      _c("span", { staticClass: "wkb-expand-history-time" }, [
                        _vm._v(_vm._s(entry.timestamp_label)),
                      ]),
                      _c(
                        "button",
                        {
                          staticClass: "wkb-expand-history-remove",
                          attrs: {
                            type: "button",
                            "aria-label": "Remove history entry",
                            disabled: _vm.loading,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("remove-entry", entry.id)
                            },
                          },
                        },
                        [_vm._v(" × ")]
                      ),
                    ]
                  ),
                ]),
                entry.summary
                  ? _c("p", { staticClass: "wkb-expand-history-summary" }, [
                      _vm._v(_vm._s(entry.summary)),
                    ])
                  : _vm._e(),
                entry.filters
                  ? _c("dl", { staticClass: "wkb-expand-history-meta" }, [
                      entry.seed_summary
                        ? _c("div", [
                            _c("dt", [_vm._v("Seeds")]),
                            _c("dd", [_vm._v(_vm._s(entry.seed_summary))]),
                          ])
                        : _vm._e(),
                      _c("div", [
                        _c("dt", [_vm._v("Target type")]),
                        _c("dd", [_vm._v(_vm._s(entry.filters.target_type))]),
                      ]),
                      _c("div", [
                        _c("dt", [_vm._v("Match")]),
                        _c("dd", [_vm._v(_vm._s(entry.filters.reducer))]),
                      ]),
                      _c("div", [
                        _c("dt", [_vm._v("Scope")]),
                        _c("dd", [
                          _vm._v(_vm._s(entry.filters.connection_scope)),
                        ]),
                      ]),
                      _c("div", [
                        _c("dt", [_vm._v("Novelty")]),
                        _c("dd", [_vm._v(_vm._s(entry.filters.novelty))]),
                      ]),
                      _c("div", [
                        _c("dt", [_vm._v("Relevance")]),
                        _c("dd", [_vm._v(_vm._s(entry.filters.relevance))]),
                      ]),
                      _c("div", [
                        _c("dt", [_vm._v("Expression")]),
                        _c("dd", [_vm._v(_vm._s(entry.filters.expression))]),
                      ]),
                    ])
                  : _vm._e(),
                entry.items?.length
                  ? _c(
                      "ul",
                      { staticClass: "wkb-expand-history-nodes" },
                      _vm._l(entry.items, function (item) {
                        return _c(
                          "li",
                          { key: `${entry.id}-${item.node_id}` },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(item.label || item.node_id)),
                            ]),
                            item.subtitle
                              ? _c("span", [_vm._v(_vm._s(item.subtitle))])
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]
            )
          }),
          0
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }